module.exports = __webpack_public_path__ + "media/puregym-classes.e06510af.mp4";